<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      app
      mobile-breakpoint="1600"
      class="font-secondary"
      persistent
      temporary
      width="350"
    >
      <template v-if="permission != null">
        <section class="primary darken-2 pa-3">
          <h3 class="white--text">{{ enterprise_name }}</h3>
          <router-link :to="`/`" class="white--text">
            <i class="fas fa-star" v-if="package_type == 'extreme'"></i>
            แพ็กเกจ{{ package_text }}
          </router-link>
        </section>
        <v-divider></v-divider>
        <!--
        <h2 class="white--text text-xs-center">{{permission.role_id}}</h2>
        -->
        <v-list shaped>
          <template v-for="(item, index) in menus">
            <v-list-item :key="index" v-if="!item.nested" :to="item.link">
              <v-list-item-title class="font-weight-bold">{{
                item.title
              }}</v-list-item-title>
            </v-list-item>

            <v-list-group :key="index" v-if="item.nested">
              <template v-slot:activator>
                <v-list-item-title class="font-weight-bold">{{
                  item.title
                }}</v-list-item-title>
              </template>

              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.link"
              >
                <v-list-item-content>
                  <v-list-item-title
                    class="pl-2"
                    v-text="child.title"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>

          <v-list-group value="true">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold"
                  >อื่นๆ</v-list-item-title
                >
              </v-list-item-content>
            </template>

            <v-list-item @click="logout()">
              <v-list-item-content>
                <v-list-item-title class="pl-2">ออกจากระบบ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-app-bar app dense fixed light color="white">
      <v-app-bar-nav-icon class="primary--text" @click.stop="drawer = !drawer">
        <img src="@/assets/img/hamburger-ico.png" style="width: 15%" />
      </v-app-bar-nav-icon>
      <v-toolbar-title class="primary--text text-uppercase">
        <span class="font-weight-bold">{{ enterprise_name }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main
      ref="mainContent"
      class="grey lighten-3"
      style="padding: 64px 0px 0px"
    >
      <router-view />
      <v-fab-transition>
        <v-btn
          v-show="
            currentRouteName == 'LiveOrders' ||
              currentRouteName == 'ScheduleOrders'
          "
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="newOrder()"
          style="z-index: 99"
        >
          <i class="fas fa-plus"></i>
        </v-btn>
      </v-fab-transition>

      <v-fab-transition>
        <v-btn
          v-show="currentRouteName == 'ShopsList'"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="newShop()"
          style="z-index: 99"
        >
          <i class="fas fa-plus"></i>
        </v-btn>
      </v-fab-transition>

      <!-- <v-fab-transition>
        <v-btn
          v-show="currentRouteName == 'CommerceOrders'"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="newCommerceOrder()"
          style="z-index: 99"
        >
          <i class="fas fa-plus"></i>
        </v-btn>
      </v-fab-transition> -->

      <v-fab-transition>
        <v-btn
          v-show="currentRouteName == 'TeamSales'"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="newTeamSales()"
          style="z-index: 99"
        >
          <i class="fas fa-plus"></i>
        </v-btn>
      </v-fab-transition>
    </v-main>

    <v-dialog persistent v-model="newOrderDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-spacer></v-spacer>มีออเดอร์มาใหม่
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-xs-center pa-3">
          <div>{{ dialogMessage }}</div>
          <v-btn block depressed large color="green" dark @click="acceptOrder"
            >ดูออเดอร์</v-btn
          >
          <v-spacer class="pa-2"></v-spacer>
          <v-btn block flat large class="red--text" @click="dismissDialog"
            >ฉันกำลังทำงานอยู่.</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <sale-team-dialog
      :showDialog="saleTeamDialog"
      @close="saleTeamDialog = false"
    >
    </sale-team-dialog>

    <!--
    <order-detail-dialog
      :dialog="showOrderDialog"
      :order_ref="`AB7AQM17`"
      @close="onOrderDetailDialogClosed"
    ></order-detail-dialog>
    -->

    <!-- <v-footer class="pa-3 grey lighten-5">
      <v-spacer></v-spacer>
      <div class="font-weight-bold text-xs-center grey--text">
        Halalize Co., Ltd © 2019 - 2022
      </div>
      <v-spacer></v-spacer>
    </v-footer> -->
  </v-app>
</template>
<script>
import Pusher from "pusher-js";
import Service from "../services";

import OrderDetailDialog from "@/components/order/DetailDialog";
import SaleTeamDialog from "@/components/team/SaleTeamDialog";

import { mapState } from "vuex";

export default {
  name: "App",
  props: {
    source: String,
  },
  components: {
    OrderDetailDialog,
    SaleTeamDialog,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  data() {
    return {
      loading: true,
      drawer: false,
      drawerRight: null,
      showOrderDialog: false,
      saleTeamDialog: false,
      newOrderFab: false,
      right: false,
      left: false,
      permission: null,
      audio: new Audio(require("../assets/sounds/Bike_Horn.mp3")),
      loaded: false,
      newOrderDialog: false,
      dialogMessage: "",
      order_id: null,
      enterprise_name: null,
      package_type: "",
      package_text: "",
      menus: [],
    };
  },
  mounted() {},
  created() {
    /*
    setTimeout(() => {
      this.$store.dispatch("Auth/getPermission").then(data => {
        this.permission = data;
        this.loading = false;
        console.log(this.permission);
      });
    }, 500);
    */

    let pusher = new Pusher("671e1c26c1aae298ee23", {
      cluster: "ap1",
      forceTLS: false,
    });

    Service.User.permission().then((resp) => {
      this.permission = resp.data;

      let channel = null;
      if (this.permission.enterprises.length == 1) {
        this.enterprise_name = this.permission.enterprises[0].ent_name;
        channel = pusher.subscribe(
          "callcenter_ent" + this.permission.enterprises[0].ent_id
        );
      } else if (this.permission.enterprises.length > 1) {
        this.enterprise_name = "HALALIZE";
      } else {
        if (this.permission.user.role_id == "super_admin") {
          this.enterprise_name = "HALALIZE";
          channel = pusher.subscribe("admin");
        } else if (this.permission.user.role_id == "shop_manager") {
          this.enterprise_name = this.permission.shops[0].name;
          this.package_text = "ผู้จัดการร้าน";
          channel = pusher.subscribe("shop_manager");
        }
      }

      channel.bind("callcenter_neworder", (data) => {
        this.order_id = data.order_id;
        this.dialogMessage = "";
        this.audio.loop = false;
        this.audio.play();
        //this.dialogMessage = data.message;
        //this.newOrderDialog = true;

        this.$notify({
          title: "แจ้งเตือน",
          message: "[#" + data.order_id + "] มีออเดอร์มาใหม่",
          type: "warning",
          duration: 5000,
          onClick: () => {
            this.$router.push(
              "/orders/" + data.order_reference + "/view?ref=push"
            );
          },
        });
      });
    });

    Service.User.getMenus().then((res) => {
      this.menus = res.data;
    });

    pusher.connection.bind("connected", function() {
      //console.log("pusher :: connected");
    });

    pusher.connection.bind("pusher:subscription_succeeded", function() {
      //console.log("pusher :: pusher:subscription_succeeded");
    });

    pusher.connection.bind("connecting", function() {
      //console.log("pusher :: connecting");
    });

    pusher.connection.bind("unavailable", function() {
      //console.log("pusher :: unavailable");
    });
  },
  methods: {
    acceptOrder() {
      this.audio.pause();
      this.newOrderDialog = false;
      this.$router.push("/view/order/" + this.order_id);
    },
    dismissDialog() {
      this.audio.pause();
      this.newOrderDialog = false;
    },
    logout() {
      this.$store.dispatch("Auth/logout").then((res) => {
        this.$router.go(this.$router.currentRoute);
      });
    },
    onOrderDetailDialogClosed() {
      this.showOrderDialog = false;
    },
    newOrder() {
      this.$router.push("/orders/create?ref=fab");
    },
    newCommerceOrder() {
      this.$router.push("/commerce/orders/create?ref=fab");
    },
    newShop() {},
    newTeamSales() {
      this.saleTeamDialog = true;
    },
  },
};
</script>
<style lang="scss">
.v-list__tile__title {
  padding-left: 20px !important;

  .v-icon {
    font-size: 12px !important;
  }
}
</style>
